export default __webpack_public_path__ + "static/media/list-message.7db1ebfd.svg";